// @ts-nocheck
import { OrderChangeRequestModel } from "@store/Framework/Types/ApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ changeRequestOrder: OrderChangeRequestModel }>;

export const DispatchSetChangeRequestOrder: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/OrderChange/SetChangeRequestOrder",
        changeRequestOrder: props.parameter.changeRequestOrder,
    });
};

export const chain = [DispatchSetChangeRequestOrder];

const setOrderChangeRequest = createHandlerChainRunner(chain, "SetChangeRequestOrder");
export default setOrderChangeRequest;
